<template>
  <div class="permission-container">
    <div class="permission-header">
      <div class="header-left">
        <div class="title-icon">
          <i class="el-icon-lock"></i>
        </div>
        <div class="title-text">
          <h3>权限管理</h3>
          <p>管理角色和子账号的访问权限</p>
        </div>
      </div>
      <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="permission-tabs">
        <el-tab-pane name="role">
          <span slot="label">
            <i class="el-icon-s-custom"></i>
            角色管理
          </span>
        </el-tab-pane>
        <el-tab-pane name="subAccount">
          <span slot="label">
            <i class="el-icon-user"></i>
            子账号管理
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'permission',
  data() {
    return {
      activeTab: 'role'
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === 'subAccount-manage') {
          this.activeTab = 'subAccount'
        } else {
          this.activeTab = 'role'
        }
      },
      immediate: true
    }
  },
  methods: {
    handleTabClick(tab) {
      if (tab.name === 'role') {
        this.$router.push('/mall/permission/role-manage')
      } else {
        this.$router.push('/mall/permission/subAccount-manage')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.permission-container {
  padding: 24px;
  background: #f5f7fa;
  min-height: calc(100vh - 100px);

  .permission-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 20px 24px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .header-left {
      display: flex;
      align-items: center;

      .title-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        border-radius: 12px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        margin-right: 16px;

        i {
          font-size: 24px;
          color: #fff;
        }
      }

      .title-text {
        h3 {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          color: #303133;
        }

        p {
          margin: 4px 0 0;
          font-size: 13px;
          color: #909399;
        }
      }
    }

    .permission-tabs {
      ::v-deep .el-tabs__header {
        margin-bottom: 0;
      }

      ::v-deep .el-tabs__nav-wrap::after {
        display: none;
      }

      ::v-deep .el-tabs__item {
        font-size: 14px;
        font-weight: 500;
        padding: 0 20px;

        i {
          margin-right: 6px;
        }

        &.is-active {
          color: #667eea;
        }
      }

      ::v-deep .el-tabs__active-bar {
        background-color: #667eea;
      }
    }
  }
}
</style>
